import {TaskSchemaNodeSection, TaskSchemaNodeSectionType} from './processFlowchartConfigEditorConstants';
import {TaskSchemaNodeRowData} from './processFlowchartConfigEditorNodeTypes';

export function convertRootRowToMapFromStartRow(rootRow: TaskSchemaNodeRowData): TaskSchemaNodeRowData {
  return {
    ...rootRow,
    isFlowchartTask: true,
    sectionName: TaskSchemaNodeSection.MAP_FROM_START,
    sectionType: TaskSchemaNodeSectionType.MAP_FROM_START,
  };
}

export function filterToAddableMapFromStartRows(
  candidateRows: Array<TaskSchemaNodeRowData>,
  existingMapFromStartRows: Array<TaskSchemaNodeRowData>
): Array<TaskSchemaNodeRowData> {
  const existingMapFromStartRowIds = existingMapFromStartRows.map((row) => row.clientId);
  return candidateRows.filter((row) => !existingMapFromStartRowIds.includes(row.clientId));
}
